import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPosthog, isPosthogConfigured } from './analytics/posthog';

initPosthog();
if (process.env.NODE_ENV === 'development' && !isPosthogConfigured()) {
  // eslint-disable-next-line no-console
  console.warn(
    '[PostHog] REACT_APP_POSTHOG_KEY is missing or invalid — no events will be sent. ' +
      'Set it in frontend/.env and restart `npm start` (CRA only reads env at startup).'
  );
}

// Strip noisy console output from production bundles. Dev still gets full
// logs for debugging. console.warn/console.error are intentionally preserved
// so real problems still surface in production browsers.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
  // eslint-disable-next-line no-console
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
